import { Toaster } from 'sonner';
import { AppProvider } from './providers/app-provider';
import { AppRoutes } from './routes';
import { QueryProvider } from './providers/query-provider';
import { ThemeProvider } from './providers/theme-provider';
import { ErrorBoundary } from './components/error-boundary';

export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryProvider>
          <AppProvider>
            <Toaster />
            <AppRoutes />
          </AppProvider>
        </QueryProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
